/**
 * Brand home (clemtex.com/<slug> with no category): an intro panel and card
 * navigation in place of the generic top-level category tiles.
 *
 * Content comes from the Brand Page records in NetSuite (customrecord_bb_brand_page
 * + its Brand Page Link cards), served as JSON by the public Suitelet
 * customscript_bb_sl_brand_page_data, whose External URL is the
 * "Brand page content URL" setting. It is fetched once per page life with
 * native fetch(): jQuery.ajax would carry SC's X-SC-Touchpoint header, which
 * forces a CORS preflight the anonymous Suitelet cannot answer.
 *
 * A brand without a record (or with the setting blank, or the feed down) gets
 * automatic cards: its busiest second-level categories. Card counts are always
 * live, from the same Item Search calls the category tiles use.
 */
define('Clemtex.Brands.Home', [
    'Clemtex.Brands.Utils',
    'clemtex_brands_home.tpl',
    'jQuery',
    'underscore'
], function (Utils, homeTemplate, jQuery, _) {
    'use strict';

    var MAX_AUTO_CARDS = 8;
    var contentPromise = null;

    function fetchContent(url) {
        if (!contentPromise) {
            var deferred = jQuery.Deferred();
            contentPromise = deferred.promise();
            if (!url || typeof window.fetch !== 'function') {
                deferred.resolve({});
            } else {
                window.fetch(url, { credentials: 'omit' })
                    .then(function (response) { return response.ok ? response.json() : {}; })
                    .then(function (data) { deferred.resolve((data && data.pages) || {}); },
                          function () { deferred.resolve({}); });
            }
        }
        return contentPromise;
    }

    function cardsFromContent(content, brand, counts) {
        return _.compact(_.map(content.cards, function (card, index) {
            var count = counts[index] || 0;
            if (!count) { return null; }   // an empty category is a dead end
            return {
                title: card.title,
                description: card.description,
                image: card.image,
                url: Utils.brandUrl(brand, card.category),
                countLabel: Utils.countLabel(count)
            };
        }));
    }

    function cardsFromTree(picked, brand) {
        return _.map(picked, function (card) {
            return {
                title: card.node.name,
                description: '',
                image: '',
                url: Utils.brandUrl(brand, card.node.fullurl),
                countLabel: Utils.countLabel(card.count)
            };
        });
    }

    return {
        // helpers: { getTree, countMany(brand), place(view, html) } from Clemtex.Brands.Tiles
        render: function render(view, settings, helpers, isCurrent) {
            var brand = view.clemtexBrand;
            var refined = _.some(view.translator.getAllFacets(), function (facet) { return facet.id !== Utils.FACET_ID; });
            var names = refined ? {} : Utils.namesFromFacets(view.model && view.model.get('facets'));
            var countMany = helpers.countMany(brand);

            jQuery.when(fetchContent(settings.contentUrl), helpers.getTree()).then(function (pages, tree) {
                var content = pages[brand.slug];
                var done = function (cards) {
                    if (!isCurrent()) { return; }
                    if (!content && !cards.length) { return helpers.place(view, ''); }
                    helpers.place(view, homeTemplate({
                        hasIntro: !!content,
                        heading: (content && content.heading) || brand.label,
                        paragraphs: content ? Utils.paragraphs(content.intro) : [],
                        highlights: (content && content.highlights) || [],
                        logo: (content && content.logo) || brand.logo || '',
                        brandName: brand.label,
                        cardsHeading: (content && content.cardsHeading) || 'Shop ' + brand.label,
                        cards: cards,
                        showHelp: !!(content && content.showHelp)
                    }));
                };

                if (content && content.cards && content.cards.length) {
                    countMany(_.map(content.cards, function (card) { return { fullurl: card.category }; }), function (counts) {
                        done(cardsFromContent(content, brand, counts));
                    });
                    return;
                }
                var candidates = Utils.homeCandidates(tree, names, settings.excludeUrls);
                if (!candidates.length) { return done([]); }
                countMany(candidates, function (counts) {
                    done(cardsFromTree(Utils.pickHomeCards(candidates, counts, settings.minItems, MAX_AUTO_CARDS), brand));
                });
            });
        }
    };
});
